import { Box, Grid, TextLink, Typography } from "@drone-js/core";
import { OneOnboardingImages } from "libs/images/oneOnboarding";
import { usePropertySelectionViewModelValue } from "../propertySelectionViewModelAtom";
import { CardSelector } from "./CardSelector";
import { CheckedItem } from "./CheckedItem";
import { PaintedDoorModal } from "./PaintedDoorModal";
import { ImportOptions } from "./constants";
import { usePaintedDoorModalOpenState } from "./paintedDoorModalOpenAtom";

export const AutomaticMethod = () => {
    const {
        importMethodCms: {
            speedDescription,
            secure,
            bComFirstSelectionText,
            flexible,
            flexibleDescription,
            fastTrackImport,
            quick,
            bComSecureDescription,
            notOnboarding,
            clickHere,
        },
    } = usePropertySelectionViewModelValue();

    const [modal, setModal] = usePaintedDoorModalOpenState();

    const handleOpenModal = () => setModal(true);
    const handleCloseModal = () => setModal(false);

    return (
        <CardSelector
            id={ImportOptions.Automatic}
            title={bComFirstSelectionText}
            logo={[OneOnboardingImages.ImportMethodAutomaticAirbnb, OneOnboardingImages.ImportMethodAutomaticBCom]}
            jacket={{
                title: fastTrackImport,
                size: "m",
                leadingIcon: "fill.symbol.lightning2",
                variant: "secondary.notice",
                position: "above",
            }}
            iconSize="48px"
            bottom={
                <Box display="flex" flexWrap="wrap" alignItems="center">
                    <Typography variant="body-s" me="8" textColor="base.subtle">
                        {notOnboarding}
                    </Typography>
                    <Box cursor="pointer">
                        <TextLink
                            hierarchy="primary"
                            label={clickHere}
                            onClick={handleOpenModal}
                            data-element-name="import-from-another-platform-link"
                        />
                    </Box>
                </Box>
            }
            data-element-name="import-from-airbnb-card"
        >
            <Box mt="24">
                <Grid spacing="12">
                    <CheckedItem title={flexible} description={flexibleDescription} />
                    <CheckedItem title={quick} description={speedDescription} />
                    <CheckedItem title={secure} description={bComSecureDescription} />
                </Grid>
            </Box>
            <PaintedDoorModal open={modal} onClose={handleCloseModal} />
        </CardSelector>
    );
};
